"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _gift_card = require("@/api/community/gift_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardAssignTaskTablePane',
  components: {},
  props: {
    fnId: {
      type: String,
      required: true
    },
    imgAccessDomain: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      listQuery: {
        giftCardFnId: this.fnId,
        page: 1,
        limit: 10,
        keywords: ''
      },
      tableKey: 0,
      tableData: [],
      total: 0,
      dialogVisible: false,
      memberList: [],
      type: '',
      // check or audit
      form: {
        assignFnId: '',
        status: ''
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleCheckRejected: function handleCheckRejected() {
      this.form.status = 'rejected';
      this.saveGiftCardCheck();
    },
    handleCheckPass: function handleCheckPass() {
      this.form.status = 'checked';
      this.saveGiftCardCheck();
    },
    saveGiftCardCheck: function saveGiftCardCheck() {
      var _this = this;
      (0, _gift_card.giftCardCheck)(this.form).then(function (res) {
        _this.$message({
          message: '操作成功',
          type: 'success'
        });
        _this.handleClose();
      });
    },
    handleAuditRejected: function handleAuditRejected() {
      this.form.status = 'rejected';
      this.saveGiftCardAudit();
    },
    handleAuditPass: function handleAuditPass() {
      this.form.status = 'executed_assigned';
      this.saveGiftCardAudit();
    },
    saveGiftCardAudit: function saveGiftCardAudit() {
      var _this2 = this;
      (0, _gift_card.giftCardAudit)(this.form).then(function (res) {
        _this2.$message({
          message: '操作成功',
          type: 'success'
        });
        _this2.handleClose();
      });
    },
    handleClose: function handleClose() {
      this.form.assignFnId = '';
      this.form.status = '';
      this.memberList = [];
      this.type = '';
      this.dialogVisible = false;
      this.search();
    },
    addAssignTask: function addAssignTask() {
      this.$emit('toAssignTaskConfig');
    },
    handlecheckStatus: function handlecheckStatus(row) {
      var _this3 = this;
      // 校对
      this.type = 'check';
      (0, _gift_card.giftCardAssginMemberList)(row.fnId).then(function (res) {
        _this3.memberList = res.data;
        _this3.form.assignFnId = row.fnId;
        _this3.dialogVisible = true;
      });
    },
    handleShowMembers: function handleShowMembers(row) {
      var _this4 = this;
      // 查看发放人员
      this.type = 'view';
      (0, _gift_card.giftCardAssginMemberList)(row.fnId).then(function (res) {
        _this4.memberList = res.data;
        _this4.form.assignFnId = row.fnId;
        _this4.dialogVisible = true;
      });
    },
    handleAuditStatus: function handleAuditStatus(row) {
      var _this5 = this;
      // 审核
      this.type = 'audit';
      (0, _gift_card.giftCardAssginMemberList)(row.fnId).then(function (res) {
        _this5.memberList = res.data;
        _this5.form.assignFnId = row.fnId;
        _this5.dialogVisible = true;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.handleFilter();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this6 = this;
      this.loading = true;
      (0, _gift_card.getGiftCardAssignPage)(this.listQuery).then(function (res) {
        _this6.tableData = res.records;
        _this6.total = res.total;
        _this6.loading = false;
      }, function () {
        _this6.loading = false;
      });
    }
  }
};